import dayjs from "dayjs";
const Invoice = ({ data }: { data: any }) => {
  console.log(data);
  const getExpiryDurationInDays = (duration: string) => {
    let days = 0;
    switch (duration) {
      case "one_month":
        days = 30;
        break;
      case "three_months":
        days = 90;
        break;
      case "six_months":
        days = 180;
        break;
      case "one_year":
        days = 365;
        break;
    }
    return days;
  };
  return (
    <table
      // className="flex flex-col -mb-8 receipt-container"
      style={{
        display: "Flex",
        flexDirection: "column",
        marginBottom: "-32px",
      }}
      dir="rtl"
      id="receipt-container"
    >
      <div
        dir="rtl"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "8px",
          textAlign: "right",
          width: "100%",
        }}
      >
        <h1
          style={{
            fontSize: "36px",
            textAlign: "right",
            fontWeight: "bold",
            paddingLeft: "16px",
            paddingRight: "12px",
            paddingBottom: "16px",
          }}
        >
          ايصال حجز
        </h1>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            paddingLeft: "16px",
            marginBottom: "16px",
            WebkitPrintColorAdjust: "exact",
            colorAdjust: "exact",
            color: "#00086D",
            backgroundColor: "#EEF0FF",
            direction: "ltr",
          }}
        >
          # {data?.id || data?.appointmentable_id}
        </span>
      </div>
      <div
        dir="rtl"
        style={{
          borderBottom: "0.5px solid #9999A7",
          display: "flex",
          alignItems: "center",
          gap: "40px",
          paddingBottom: "16px",
          paddingLeft: "16px",
          paddingRight: "16px",
          marginBottom: "-16px",
        }}
      >
        <span
          style={{
            color: "#020418",
            fontWeight: "normal",
            fontSize: "18px",
          }}
        >
          تاريخ الايصال
        </span>
        <span
          style={{
            color: "#00086D",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          {dayjs(data?.created_at).format("DD-MM-YYYY")}
        </span>
      </div>
      <div
        dir="rtl"
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "18px",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            fontSize: "16px",
            padding: "24px 0",
            width: "200px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "4px",
            }}
          >
            ايصال مقدم الى
          </span>
          <span
            style={{
              display: "flex",
              gap: "4px",
              fontWeight: "bold",
              fontSize: "16px",
              color: "#00086D",
            }}
          >
            {data?.appointmentable?.full_name ||
              data?.appointmentable?.name ||
              data?.client_profile?.full_name ||
              data?.client_profile?.name || (
                <>
                  <span>
                    {data?.appointmentable?.first_name ||
                      data?.first_name ||
                      data?.client_profile?.first_name}
                  </span>
                  <span>
                    {data?.appointmentable?.last_name ||
                      data?.last_name ||
                      data?.client_profile?.last_name}
                  </span>
                </>
              )}
          </span>
          <span
            style={{
              fontSize: "16px",
              color: "#00086D",
            }}
          >
            {data?.appointmentable?.email ||
              data?.email ||
              data?.client_profile?.email}
          </span>
          <span
            style={{
              display: "flex",
              justifyContent: "flex-start",
              fontSize: "16px",
              color: "#00086D",
              direction: "ltr",
            }}
          >
            {data?.appointmentable?.phone ||
              data?.phone ||
              data?.client_profile?.phone}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            fontSize: "16px",
            padding: "24px 0",
            width: "200px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "4px",
            }}
          >
            من
          </span>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              color: "#00086D",
            }}
          >
            {data?.location?.name || Location?.name || ""}
          </span>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              color: "#00086D",
            }}
          >
            {data?.location?.email || ""}
          </span>
          <span
            style={{
              display: "flex",
              flexWrap: "wrap",
              color: "#00086D",
              maxWidth: "50px",
            }}
          >
            <span>{data?.location?.business_location?.City || ""}</span>{" "}
            <div style={{ display: "flex" }}>
              <span>{data?.location?.business_location?.District || ""}</span>
              <span>
                {data?.location?.business_location?.Building || ""}
              </span>{" "}
            </div>
          </span>
          <span
            style={{
              display: "flex",
              justifyContent: "flex-start",
              fontSize: "16px",
              color: "#00086D",
              direction: "ltr",
            }}
          >
            {data?.location?.contact_number || ""}
          </span>
        </div>
      </div>
      <div
        dir="rtl"
        style={{
          backgroundColor: "#EEF0FF",
          color: "#020418",
          fontWeight: "600",
          WebkitPrintColorAdjust: "exact",
          colorAdjust: "exact",
          padding: "8px 16px", // Equivalent to px-4 py-2
          margin: "8px 0 8px 0", // Equivalent to my-2 mt-0
          display: "flex", // Flexbox display
          alignItems: "center", // Center items vertically, equivalent to items-center
          justifyContent: "center", // Center content horizontally, equivalent to justify-center
          width: "100%", // Full width, equivalent to w-full
          textAlign: "center", // Center text, equivalent to text-center
        }}
      >
        تفاصيل الحجز
      </div>
      <div
        dir="rtl"
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          fontSize: "16px", // Equivalent to text-base
          gap: "4px", // Close approximation to gap-1
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              borderBottom: "1px solid #9999A7",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                padding: "16px 16px 8px 16px", // Tailwind p-4 py-2 equivalent
              }}
            >
              السعر
            </span>
            <span
              style={{
                fontWeight: "bold",
                padding: "16px 16px 8px 16px", // Tailwind p-4 py-2 equivalent
                color: "#020418",
              }}
            >
              الخدمات و المنتجات
            </span>
          </div>

          {data?.sale_items?.map((item: any, index: any) => {
            const renderSaleItem = (item: any) => {
              switch (item.itemable_type) {
                case "Membership":
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        borderBottom: "1px solid #9999A7",
                        padding: "16px", // Tailwind p-4 equivalent
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px", // Close approximation to gap-2
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#00086D",
                          }}
                        >
                          {item?.itemable?.name}
                        </span>
                        <span
                          dir="ltr"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontWeight: "normal",
                            color: "#00086D",
                          }}
                        >
                          <span dir="rtl">
                            {item.itemable?.pricingOption?.length || 0} خدمات
                          </span>
                          -
                          <span dir="rtl">
                            {item.itemable?.number_sessions ||
                              item.itemable?.sessions}
                            <span style={{ margin: "0 2px" }}>جلسات</span>
                          </span>
                          -
                          <span dir="rtl">
                            {getExpiryDurationInDays(
                              item?.itemable?.expire_duration
                            )}
                            <span style={{ margin: "0 2px" }}>يوم</span>
                          </span>
                        </span>
                      </div>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#00086D",
                        }}
                      >
                        {item.itemable.price ||
                          item.itemable.selected_pricing_option?.price ||
                          0}
                        <span style={{ margin: "0 2px" }}> ريال سعودي</span>
                      </span>
                    </div>
                  );
                case "GiftCardValue":
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        borderBottom: "1px solid #9999A7",
                        padding: "16px", // Tailwind p-4 equivalent
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px", // Close approximation to gap-2
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#00086D",
                          }}
                        >
                          كارت هدايا #{item?.itemable?.id}
                        </span>
                        <span
                          dir="ltr"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontWeight: "normal",
                            color: "#00086D",
                          }}
                        >
                          <span dir="rtl">
                            {
                              item?.itemable?.gift_card?.voucher_duration?.days_difference.split(
                                " "
                              )[0]
                            }
                            <span style={{ margin: "0 2px" }}>يوم</span>
                          </span>
                        </span>
                      </div>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#00086D",
                        }}
                      >
                        {item?.itemable?.value}
                        <span style={{ margin: "0 2px" }}> ريال سعودي</span>
                      </span>
                    </div>
                  );
                case "PricingOption":
                  console.log(item);
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        borderBottom: "1px solid #9999A7",
                        padding: "16px", // Tailwind p-4 equivalent
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px", // Close approximation to gap-2
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#00086D",
                          }}
                        >
                          {item?.itemable?.service?.name}
                        </span>
                        <span
                          dir="ltr"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontWeight: "normal",
                            color: "#00086D",
                          }}
                        >
                          <span dir="rtl">
                            {item?.team_member?.title}
                            {" : "}
                            {item?.team_member?.name}
                          </span>
                        </span>
                      </div>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#00086D",
                        }}
                      >
                        {item.itemable.price || 0}
                        <span style={{ margin: "0 2px" }}> ريال سعودي</span>
                      </span>
                    </div>
                  );
                case "Product":
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        borderBottom: "1px solid #9999A7",
                        padding: "16px", // Tailwind p-4 equivalent
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px", // Close approximation to gap-2
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#00086D",
                          }}
                        >
                          {item?.itemable?.name}
                        </span>
                        <span
                          dir="ltr"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontWeight: "normal",
                            color: "#00086D",
                          }}
                        >
                          <span dir="rtl">{item?.itemable?.name}</span>
                        </span>
                      </div>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#00086D",
                        }}
                      >
                        {item?.quantity > 1 && (
                          <span className="" style={{ margin: "0 2px 0 0px" }}>
                            {item?.quantity}x
                          </span>
                        )}
                        {item?.itemable?.retail_price ||
                          item.itemable.price ||
                          item.itemable.selected_pricing_option?.price ||
                          0}
                        <span style={{ margin: "0 2px" }}> ريال سعودي</span>
                      </span>
                    </div>
                  );

                default:
                  return <div></div>;
              }
            };
            console.log(item);
            return renderSaleItem(item);
          })}
        </div>
      </div>
      <div
        dir="rtl"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          fontSize: "16px", // Equivalent to text-base
          marginBottom: "64px", // Equivalent to mb-16
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "384px", // Equivalent to w-96
            borderBottom: "1px solid #9999A7",
            padding: "16px 12px",
          }}
        >
          <span style={{ color: "#75757E", fontWeight: "500" }}>الاجمالي</span>
          <span style={{ color: "#020418", fontWeight: "500" }}>
            {data?.subtotal || data?.cost || data?.totalPrice} ريال سعودي
          </span>
        </div>
        <div
          style={{
            display: "flex",
            gap: "4px",
            justifyContent: "space-between",
            width: "384px",
            padding: "16px 12px",
            borderBottom: "1px solid #9999A7",
          }}
        >
          <span style={{ color: "#75757E", fontWeight: "400" }}>
            الاجمالي + الضريبة
          </span>
          <span
            style={{
              color: "#020418",
              fontWeight: "500",
              marginLeft: "2px",
              marginRight: "2px",
            }}
          >
            {data?.total ||
              +data?.taxable?.tax_rate + (+data?.cost || +data?.pay) ||
              0}
            <span> ريال سعودي</span>
          </span>
        </div>
        {data?.payment_method?.name && (
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "space-between",
              width: "384px",
              padding: "16px 12px",
            }}
          >
            <span style={{ color: "#75757E", fontWeight: "400" }}>
              طريقة الدفع
            </span>
            <span
              style={{
                color: "#020418",
                fontWeight: "500",
                marginLeft: "2px",
                marginRight: "2px",
              }}
            >
              {data?.payment_method?.name}
            </span>
          </div>
        )}
        {data?.discount && (
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "space-between",
              width: "384px",
              padding: "16px 12px",
              borderBottom: "1px solid #9999A7",
            }}
          >
            <span style={{ color: "#75757E", fontWeight: "400" }}>الخصم</span>
            <span
              style={{
                color: "#020418",
                fontWeight: "500",
                marginLeft: "2px",
                marginRight: "2px",
              }}
            >
              {data?.discount}
              <span> ريال سعودي</span>
            </span>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "384px",
            background: "#EEF0FF",
            gap: "2px",
            colorAdjust: "exact",
            WebkitPrintColorAdjust: "exact",
            padding: "16px 12px",
          }}
        >
          <span style={{ color: "#020418", fontWeight: "600" }}>
            المبلغ المستحق
          </span>
          <span
            style={{
              color: "#00086D",
              fontWeight: "bold",
              marginLeft: "2px",
              marginRight: "2px",
            }}
          >
            {data?.taxable?.tax_rate
              ? +data?.taxable?.tax_rate +
                (+data?.pay || +data?.total || +data?.totalPrice || +data?.cost)
              : data?.pay || data?.total || data?.totalPrice || data?.cost}
            <span> ريال سعودي</span>
          </span>
        </div>
      </div>
    </table>
  );
};

export default Invoice;
